import React from 'react';
import Firebase from 'firebase';
import Row from './row';
import Picker from 'react-month-picker'
import MonthBox from './monthbox'



export default class tabla extends React.Component {
    constructor() {
        super();
        this.state = {
            key: ""
        }
    }


    componentDidMount() {
        const contex = this;
        var formRef = Firebase.database().ref("forms").orderByChild("client_id").equalTo(localStorage.client_id);
        formRef.once("value").then(resp => {
            resp.forEach(function (childSnapshot) {
                if (childSnapshot.val().tag === "CDA") {
                    contex.setState({ key: childSnapshot.key })
                }
            });
        })
    }

    setRow(obj) {

    }

    render() {
        return (
            <div className="col-md-12" style={{overflow : "auto"}}>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Auditor</th>
                            {
                                this.props.days.map((d) => (
                                    <th style={{ width: "80px"}}>{d}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.auditores.map((a, index) => (
                                <tr key={index}>
                                    <td>
                                        {a.label}
                                    </td>
                                    {this.state.key ?
                                        this.props.dias.map((d, index2) => (
                                            <Row
                                                key={index2}
                                                user={a}
                                                day={d}
                                                month={this.props.month}
                                                year={this.props.year}
                                                num_days={this.props.num_days}
                                                form={this.state.key}
                                                callBack={(e) => { this.props.callBack(e) }}
                                            />
                                        ))
                                        :
                                        ""
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/tabla.js